import {HttpEvent, HttpHandlerFn, HttpRequest} from '@angular/common/http'
import {inject} from '@angular/core'
import {Observable, switchMap} from 'rxjs'
import {ConfigService} from '../services/config.service'

/**
 * Set this token to true in a request's context
 * to skip adding the 'Authorization' header.
 *

 /**
 * Adds 'Authorization: Bearer <token>' header to requests.
 *
 * Skips adding the header if:
 * - No token exists.
 * - The request context has `DISABLE_AUTH` set to true.
 *
 */
export const authInterceptor = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const configService = inject(ConfigService)
  return configService.accessToken$
    .pipe(
      switchMap(token => {
        const headers = req.headers

        // Skip auth if we don't have a token
        if (!token) {
          return next(req)
        }

        // Add the token to the request header
        const authReq = req.clone({
          headers: headers.set('Authorization', `Bearer ${token.accessToken}`)
        })
        return next(authReq)
      })
    )
}
